/** Shared color tokens for progress report — portal preview (hex) and Excel export (ARGB). */

export const HEX = {
    // Header
    headerBg:        '#001529',
    groupHeaderBg:   '#002140',
    subHeaderBg:     '#003a6e',
    headerText:      '#ffffff',
    groupHeaderText: '#91caff',
    subHeaderText:   '#e6f4ff',
    headerBorder:    '#0050a0',

    // Rows
    rowBg:    '#fafafa',
    rowBorder: '#f0f0f0',

    // Status backgrounds
    passedBg:      '#d9f7d0',
    failedBg:      '#fff1f0',
    warnBg:        '#ffe7c7',
    notStartedBg:  '#f5f5f5',
    proposedBg:    '#d6e8ff',
    updatedBg:     '#e9d8fd',
    completedWfBg: '#c7f5ed',
    underReviewBg: '#fffb8f', // trainer-led "Under review" (yellow highlight)

    // Status text
    passedText:      '#389e0d',
    failedText:      '#cf1322',
    warnText:        '#d46b08',
    notStartedText:  '#8c8c8c',
    proposedText:    '#0050a0',
    updatedText:     '#531dab',
    completedWfText: '#006d75',
    underReviewText: '#ad6800',

    // Misc
    secondaryText: '#8c8c8c',
    emailText:     '#595959',
};

export const ARGB = {
    // Title / summary banner
    titleBg:    'FF001529',
    titleText:  'FFFFFFFF',
    summaryBg:  'FFF0F9FF',
    summaryText:'FF374151',

    // Column header (fixed cols: Name, Email, summary)
    headerBg:     'FF001529',
    headerText:   'FFFFFFFF',
    headerBorder: 'FF0050A0',

    // Group / sub-header row (hierarchy level 1 and 2)
    groupHeaderBg:   'FF002140',
    groupHeaderText: 'FF91CAFF',
    subHeaderBg:     'FF003A6E',
    subHeaderText:   'FFE6F4FF',

    // Rows
    rowBg:     'FFFAFAFA',
    rowBorder: 'FFF0F0F0',

    // Status backgrounds
    passedBg:      'FFD9F7D0',
    failedBg:      'FFFFF1F0',
    warnBg:        'FFFFE7C7',
    notStartedBg:  'FFF5F5F5',
    proposedBg:    'FFD6E8FF',
    updatedBg:     'FFE9D8FD',
    completedWfBg: 'FFC7F5ED',
    underReviewBg: 'FFFFFB8F',

    // Status text
    passedText:      'FF389E0D',
    failedText:      'FFCF1322',
    warnText:        'FFD46B08',
    notStartedText:  'FF8C8C8C',
    proposedText:    'FF0050A0',
    updatedText:     'FF531DAB',
    completedWfText: 'FF006D75',
    underReviewText: 'FFAD6800',

    // Score / credit colours
    scoreGood: 'FF389E0D',
    scoreWarn: 'FFD46B08',
    scoreBad:  'FFCF1322',
    scoreNone: 'FF8C8C8C',

    // Misc
    secondaryText: 'FF8C8C8C',
    emailText:     'FF595959',
};

export const WORKFLOW_LABEL: Record<string, string> = {
    proposed:         'Proposed',
    proposed_changes: 'Changes Req.',
    updated:          'Updated',
    approved:         'Approved',
    completed:        'Completed',
};

export const WORKFLOW_BG_HEX: Record<string, string> = {
    proposed:         HEX.proposedBg,
    proposed_changes: HEX.warnBg,
    updated:          HEX.updatedBg,
    approved:         HEX.passedBg,
    completed:        HEX.completedWfBg,
};

export const WORKFLOW_FG_HEX: Record<string, string> = {
    proposed:         HEX.proposedText,
    proposed_changes: HEX.warnText,
    updated:          HEX.updatedText,
    approved:         HEX.passedText,
    completed:        HEX.completedWfText,
};

export const WORKFLOW_BG_ARGB: Record<string, string> = {
    proposed:         ARGB.proposedBg,
    proposed_changes: ARGB.warnBg,
    updated:          ARGB.updatedBg,
    approved:         ARGB.passedBg,
    completed:        ARGB.completedWfBg,
};

export const WORKFLOW_FG_ARGB: Record<string, string> = {
    proposed:         ARGB.proposedText,
    proposed_changes: ARGB.warnText,
    updated:          ARGB.updatedText,
    approved:         ARGB.passedText,
    completed:        ARGB.completedWfText,
};
